export default "__VITE_ASSET__eXntjQfP$tLNjMF8CEy37A__"